import { render, staticRenderFns } from "./Project_Management.vue?vue&type=template&id=4ea9828f&scoped=true&"
import script from "./Project_Management.vue?vue&type=script&lang=js&"
export * from "./Project_Management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea9828f",
  null
  
)

export default component.exports